<div class="relative h-full w-full bg-gray-200">
  @if (validPhotos().length > 0) {
    <swiper-container
      class="h-full w-full"
      pagination="true"
      pagination-clickable="true"
      slides-per-view="1"
      space-between="0"
      grab-cursor="true"
    >
      @for (photo of validPhotos(); track $index) {
        <swiper-slide>
          <img
            class="h-full w-full object-cover"
            [alt]="'Property image ' + ($index + 1)"
            [src]="photo"
            (error)="onImageError(photo)"
          />
        </swiper-slide>
      }
    </swiper-container>

    <!-- Overlay pagination dots (styled) -->
    <div class="absolute left-0 right-0 top-3 flex justify-center">
      <div class="rounded-full bg-black/40 px-3 py-1 text-xs text-white">Swipe →</div>
    </div>
  } @else {
    <div class="flex flex-col h-full items-center justify-center text-gray-400">
      <svg class="mx-auto mb-2 h-12 w-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        ></path>
      </svg>
      <p class="text-sm">Μη διαθέσιμες φωτογραφίες</p>
    </div>
  }
</div>
